import { render } from "./add-charge.vue?vue&type=template&id=29e765f4"
import script from "./add-charge.vue?vue&type=script&lang=js"
export * from "./add-charge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__